import React from "react";
import DropDownMenu from "../../components/common/DropDownMenu";
import { getHelpMenu } from "./constant";

type HelpProps = {
    imageSetsName: string
}

/**
 * This component is for the "Help" menu, provide a dynamic list of sub-menu info
 */
const Help: React.FunctionComponent<HelpProps> = (props: HelpProps) => {

    const helpMenu = getHelpMenu(props.imageSetsName);

    return (
        <DropDownMenu buttonText="Help" menuItems={helpMenu} />
    );
}

export default Help;
